const customEvents = 'customEvents';

export const FETCH_CUSTOM_EVENTS_RESPONSE = `${customEvents}/FETCH_CUSTOM_EVENTS_RESPONSE`;
export const FETCH_CUSTOM_EVENTS_REQUEST = `${customEvents}/FETCH_CUSTOM_EVENTS_REQUEST`;
export const FETCH_CUSTOM_EVENTS_ERROR = `${customEvents}/FETCH_CUSTOM_EVENTS_ERROR`;

export const FETCH_DELETION_POLICIES_BY_PROJECT_REQUEST = `${customEvents}/FETCH_DELETION_POLICIES_BY_PROJECT_REQUEST`;
export const FETCH_DELETION_POLICIES_BY_PROJECT_RESPONSE = `${customEvents}/FETCH_DELETION_POLICIES_BY_PROJECT_RESPONSE`;
export const FETCH_DELETION_POLICIES_BY_PROJECT_ERROR = `${customEvents}/FETCH_DELETION_POLICIES_BY_PROJECT_ERROR`;

export const UPDATE_DELETION_POLICIES_REQUEST = `${customEvents}/UPDATE_DELETION_POLICIES_REQUEST`;
export const UPDATE_DELETION_POLICIES_RESPONSE = `${customEvents}/UPDATE_DELETION_POLICIES_RESPONSE`;
export const UPDATE_DELETION_POLICIES_ERROR = `${customEvents}/UPDATE_DELETION_POLICIES_ERROR`;
